module.exports = __webpack_public_path__ + "img/collectiongallery_signet@2x.b58e1a3.jpg";